import { render, staticRenderFns } from "./allPrjPerm.vue?vue&type=template&id=fdef4816&scoped=true"
import script from "./allPrjPerm.vue?vue&type=script&lang=js"
export * from "./allPrjPerm.vue?vue&type=script&lang=js"
import style0 from "./allPrjPerm.vue?vue&type=style&index=0&id=fdef4816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdef4816",
  null
  
)

export default component.exports